export default Object.freeze({

  DefaultState: () => ({
    timer: {
      duration: '00:00:00',
      trueClockInTime: null,
      timeZoneOffset: null,
    },
    activeTimePair: {
      id: null,
      employeeAssignment: null,
      clockIn: null,
      clockOut: null,
      startDate: null,
      isCallBack: false,
      isCorrection: null,
      isManualPair: null,
      timePairCustomFieldValues: [],
    },
    version: '',
    license: {
      name: '',
      expiry_date: '',
    },
    activeSegment: null,
    activeSegmentType: 'SHIFT',
    menuData: {
      pageTitle: '',
    },
    notificationCount: 0,
    notifications: [],
    approvalsByUsername: {},
    approvalStatusConfiguration: [],
    timePairSelectability: {},
    employeeAbsences: {},
    allCurrentEmployeePairsSelected: {},
    allCurrentTimePairsSelected: false,
    activeFilters: [],
    subordinateEmployees: [],
    employee: {},
    userConfiguration: {
      is24HourDateTime: false,
    },
    profileLoading: false,
    timePairs: [],
    correctionReasons: [],
    locales: [],
    warnedOfMissedClockOut: false,
    workSchedules: [],
    workSchedulesByExternalCode: {},
    dailyWorkScheduleByEmployee: {},
    assignedWorkScheduleRanges: {},
    employeeSchedules: {},
    featureSwitches: {},
    featureSchedules: {},
    tempWorkScheduleAssignmentStatusPolling: false,
    geofence: [],
    pendingWorkSchedules: [],
    snackbar: {
      visible: false,
      text: null,
      color: null,
      buttonHandler: null,
      buttonText: null,
    },
    appDialog: {
      confirm: false,
      warn: false,
      error: false,
      message: null,
      color: null,
      confirmText: null,
      confirmHandler: null,
      cancelText: null,
      cancelHandler: null,
    },
    appLoader: {
      visible: false,
      text: null,
    },
    googleMapsApi: null,
    theme: {
      primary: '#01579B',
      secondary: '#012a4e',
      info: '#e5edf7',
      accent: {
        base: '#f8d612',
        lighten1: '#fae361',
      },
      error: '#ef5350',
      warning: '#ee862b',
      success: {
        base: '#39c844',
        lighten1: '#89e75f',
        lighten2: '#b5e89d',
        darken1: '#67ae28',
        darken2: '#589622',
      },
    },
  }),

  LocalStorage: {
    NO_LOCATION_DATA: 'noLocationData',
  },

  DataTableHeaderValues: {
    DATA_TABLE_SELECT: 'data-table-select',
    POSITION: 'position',
    START_DATE: 'startDate',
    CLOCK_IN: 'clockIn',
    CLOCK_OUT: 'clockOut',
    DURATION: 'duration',
    EXPECTED_DURATION: 'expectedDuration',
    STATUS: 'status',
    NAME: 'name',
    DETAILS: 'details',
    INFO: 'info',
    ACTIONS: 'actions',
    APPROVALS: 'approvals',
    ENTRY_TYPE: 'entryType',
    DATE: 'date',
    TIME: 'time',
    CORRECTION_DATE: 'correctionDate',
    MODIFIED_BY: 'modifiedBy',
    REASON: 'reason',
    CLONE: 'clone',
    EMPLOYEE_ID: 'employeeId',
    ABSENCE_TYPE: 'absenceType',
  },

  EntryType: {
    CLOCK_IN: 'CLOCK_IN',
    CLOCK_OUT: 'CLOCK_OUT',
  },

  TimePairType: {
    CLOCK: 'Clock',
    CORRECTION: 'Correction',
    MANUAL: 'Manual',
    SHIFT: 'SHIFT',
    SEGMENT: 'SEGMENT',
    BREAK: 'BREAK',
  },

  TimeType: {
    Category: {
      ATTENDANCE: 'ATTENDANCE',
      BREAK: 'BREAK',
      EXTRA: 'EXTRA',
      ABSENCE: 'ABSENCE',
      ONCALL: 'ONCALL',
    },
  },

  AppColors: {
    NONE: 'none',
    INFO: 'info',
    WARN: 'warning',
    ERROR: 'error',
    SUCCESS: 'success',
    PRIMARY: 'primary',
  },

  LocationData: {
    NO_LOCATION_DATA_VALUE: -1,

    GeofenceResult: {
      INSIDE: 'INSIDE',
      OUTSIDE: 'OUTSIDE',
      BORDERING_INSIDE: 'BORDERING_INSIDE',
      BORDERING_OUTSIDE: 'BORDERING_OUTSIDE',
      NO_GEOFENCE: 'NO_GEOFENCE',
    },
  },

  Notifications: {
    NotificationTypeId: {
      MISSED_CLOCKOUT: 'missed-clockout',
      MISSED_BREAKOUT: 'missed-breakout',
      MANAGER_REJECTED: 'manager-rejected',
      MANAGER_APPROVED: 'manager-approved',
      MANAGER_ADDED: 'manager-added',
      MANAGER_EDITED: 'manager-edited',
    },
    Priority: {
      HIGH: 'High',
      MED: 'Medium',
      LOW: 'Low',
      NONE: 'None',
    },
    Colors: {
      HIGH: '#c0392b',
      MED: '#e67e22',
      LOW: '#279d53',
      INFO: '#2980b9',
    },
  },

  Approvals: {
    Status: {
      APPROVED: 'APPROVED',
      REJECTED: 'REJECTED',
      PENDING: 'PENDING',
      PENDING_DELETE: 'PENDING_DELETE',
      INCOMPLETE: 'INCOMPLETE',
    },
    TIME_PAIRS_PER_PAGE: 30,
    TIME_PAIRS_PER_PAGE_MOBILE: 5,
  },

  TimePairCustomField: {
    Type: {
      FLAG: 'FLAG',
      SELECT: 'SELECT',
      COMBOBOX: 'COMBOBOX',
    },
  },

  WorkSchedule: {
    ABSENCE: 'ABSENCE',
    SegmentType: {
      SCHEDULED_WORKING_TIME: 'SCHEDULED_WORKING_TIME',
      SCHEDULED_UNPAID_BREAK: 'SCHEDULED_UNPAID_BREAK',
      FLEXTIME_BANDWIDTH: 'FLEXTIME_BANDWIDTH',
      ACTUAL_WORKING_TIME: 'ACTUAL_WORKING_TIME',
      ONGOING_WORK_TIME: 'ONGOING_WORK_TIME',
      UNSCHEDULED_WORK: 'UNSCHEDULED_WORK',
      MISSED_WORK: 'MISSED_WORK',
      ACTUAL_BREAK_TIME: 'ACTUAL_BREAK_TIME',
      ONGOING_BREAK_TIME: 'ONGOING_BREAK_TIME',
      MISSED_BREAK: 'MISSED_BREAK',
      BREAK: 'BREAK',
      OT_BREAK: 'OT_BREAK',
      EXTENDED_BREAK: 'EXTENDED_BREAK',
      PLACEHOLDER: 'PLACEHOLDER',
      OVERTIME: 'OVERTIME',
      ONGOING_OVERTIME: 'ONGOING_OVERTIME',
      FIXED_OVERTIME: 'FIXED_OVERTIME',
      FIXED_OVERTIME_WORKING_TIME: 'FIXED_OVERTIME_WORKING_TIME',
      EARLY_LOGIN: 'EARLY_LOGIN',
      PRE_SHIFT_OT: 'PRE_SHIFT_OT',
      UNKNOWN: 'UNKNOWN',
    },
    TimeType: {
      OVERTIME: 'OT_Extra',
      FIXED_OVERTIME: 'OT_Fix',
      EARLY_LOGIN: 'Early_Login',
      PRE_SHIFT_OT: 'Pre-Shift Overtime',
    },
    Filters: {
      UNDER_TIME: 'Under Time',
      OVERTIME: 'Overtime',
    },
    TimeRecordingVariant: {
      CLOCK_TIME: 'CLOCK_TIME',
      DURATION: 'DURATION',
    },
    DayCategory: {
      DAY_MODEL: 'DAY_MODEL',
      PLANNED_HOURS: 'PLANNED_HOURS',
      WORKING_DAY: 'WORKING_DAY',
      OFF: 'OFF',
    },
    ViewRange: {
      WEEK: 'WEEK',
      MONTH: 'MONTH',
    },
    MINUTES_IN_DAY: 1440,
    Colours: [
      {
        darken1: {
          shade: '#BFC41C',
          textColour: 'black',
        },
        base: {
          shade: '#DEE33F',
          textColour: 'black',
        },
        lighten1: {
          shade: '#E4E86F',
          textColour: 'black',
        },
        lighten2: {
          shade: '#E9EC93',
          textColour: 'black',
        },
        lighten3: {
          shade: '#EEF2B7',
          textColour: 'black',
        },
      },
      {
        darken1: {
          shade: '#814D22',
          textColour: 'white',
        },
        base: {
          shade: '#BD7133',
          textColour: 'white',
        },
        lighten1: {
          shade: '#c78852',
          textColour: 'white',
        },
        lighten2: {
          shade: '#d4a172',
          textColour: 'black',
        },
        lighten3: {
          shade: '#E3BC9B',
          textColour: 'black',
        },
      },
      {
        darken1: {
          shade: '#3A182F',
          textColour: 'white',
        },
        base: {
          shade: '#642951',
          textColour: 'white',
        },
        lighten1: {
          shade: '#783F68',
          textColour: 'white',
        },
        lighten2: {
          shade: '#916682',
          textColour: 'black',
        },
        lighten3: {
          shade: '#AD8DA2',
          textColour: 'black',
        },
      },
      {
        darken1: {
          shade: '#15291A',
          textColour: 'white',
        },
        base: {
          shade: '#1F3E28',
          textColour: 'white',
        },
        lighten1: {
          shade: '#345544',
          textColour: 'white',
        },
        lighten2: {
          shade: '#5B7262',
          textColour: 'black',
        },
        lighten3: {
          shade: '#87978C',
          textColour: 'black',
        },
      },
      {
        darken1: {
          shade: '#14497B',
          textColour: 'white',
        },
        base: {
          shade: '#1D6BB2',
          textColour: 'white',
        },
        lighten1: {
          shade: '#4D7FBC',
          textColour: 'white',
        },
        lighten2: {
          shade: '#7896CA',
          textColour: 'black',
        },
        lighten3: {
          shade: '#A0B3DB',
          textColour: 'black',
        },
      },
      {
        darken1: {
          shade: '#17274F',
          textColour: 'white',
        },
        base: {
          shade: '#223871',
          textColour: 'white',
        },
        lighten1: {
          shade: '#485283',
          textColour: 'white',
        },
        lighten2: {
          shade: '#6E7099',
          textColour: 'black',
        },
        lighten3: {
          shade: '#9096AC',
          textColour: 'black',
        },
      },
    ],
  },

  EC_SYNCHRONISATION_STATUS: {
    SYNCHRONISED: 'SYNCHRONISED',
    SYNCHRONISATION_PENDING: 'SYNCHRONISATION_PENDING',
    SYNCHRONISATION_FAILED: 'SYNCHRONISATION_FAILED',
  },

  Navigation: {
    EMPLOYEE_CLOCKING_TAB_TITLE: 'My Clock',
    EMPLOYEE_TIME_TAB_TITLE: 'My History',
    EMPLOYEE_WORK_SCHEDULES_TAB_TITLE: 'My Schedule',
    MANAGER_APPROVAL_TABLE_TITLE: 'Employee Time',
    MANAGER_CLOCKING_TAB_TITLE: 'Employee Clocking',
    MANAGER_WORK_SCHEDULES_TAB_TITLE: 'Employee Schedules',
  },

  TimePairStatusIndicator: {
    PENDING_DELETE: 'Deletion requested for time which has already been approved',
  },

  ServerLoggerType: {
    INFO: 'INFO',
    DEBUG: 'DEBUG',
    WARN: 'WARN',
    ERROR: 'ERROR',
  },

  LICENSE_BASE_PRODUCT_CODE: 'SOME-CODE-BASE',

  MINIMUM_SEARCH_LENGTH: 3,

  CLOCK_OUT_DELAY_IN_MILLISECONDS: 0,

  SERVER_ACTIVE_SHIFT_PING_DELAY: 10000,

  Properties: {
    PAY_CYCLE_START_DATE: '2021/11/01',
  },

  NONE: 'None',

  FEATURE_SWITCHES_TITLES: {
    SELECTABLE_TIME_TYPES: 'SELECTABLE_TIME_TYPES',
    ADD_TIME_PAIRS: 'ADD_TIME_PAIRS',
    EDIT_TIME_PAIRS: 'EDIT_TIME_PAIRS',
    APPROVE_TIME_PAIRS: 'APPROVE_TIME_PAIRS',
    SEGMENT_TIME_PAIRS: 'SEGMENT_TIME_PAIRS',
    FILTER_APPROVALS_BY_STATUS: 'FILTER_APPROVALS_BY_STATUS',
    WORK_SCHEDULES_MANAGER_VIEW: 'WORK_SCHEDULES_MANAGER_VIEW',
    WORK_SCHEDULES_EMPLOYEE_VIEW: 'WORK_SCHEDULES_EMPLOYEE_VIEW',
    LOCATION: 'LOCATION',
    GEOFENCE: 'GEOFENCE',
    DELETE_TIME_PAIRS: 'DELETE_TIME_PAIRS',
    FREE_TEXT_CORRECTION_REASONS: 'FREE_TEXT_CORRECTION_REASONS',
    MISSED_CLOCK_OUT_NOTIFICATIONS: 'MISSED_CLOCK_OUT_NOTIFICATIONS',
    MISSED_CLOCK_IN_NOTIFICATIONS: 'MISSED_CLOCK_IN_NOTIFICATIONS',
    CONCURRENT_EMPLOYMENT: 'CONCURRENT_EMPLOYMENT',
    NO_CUSTOM_FIELDS: 'NO_CUSTOM_FIELDS',
    AUTO_CLOCK_OUT: 'AUTO_CLOCK_OUT',
    DISABLE_BREAK_OUT_NOTIFICATION: 'DISABLE_BREAK_OUT_NOTIFICATION',
    CLONE_TIME_PAIRS: 'CLONE_TIME_PAIRS',
    SAML_AUTH: 'SAML_AUTH',
  },

  REASON_IDS: {
    OTHER_ID: 6,
  },
});
